import { useState } from 'react';

export const useFilters = () => {
  const [selectedThirdSectionFilters, setSelectedThirdSectionFilters] = useState<Set<string>>(
    new Set(['all']),
  );
  const [selectedFourthSectionFilters, setSelectedFourthSectionFilters] = useState<Set<string>>(
    new Set(['all']),
  );

  const toggleFilter = (
    currentFilters: Set<string>,
    setFilters: (filters: Set<string>) => void,
    value: string,
  ) => {
    const newFilters = new Set(currentFilters);

    if (value === 'all') {
      newFilters.clear();
      newFilters.add('all');
    } else {
      newFilters.delete('all');
      if (newFilters.has(value)) {
        newFilters.delete(value);
      } else {
        newFilters.add(value);
      }
      if (newFilters.size === 0) {
        newFilters.add('all');
      }
    }

    setFilters(newFilters);
  };

  const toggleThirdSectionFilter = (value: string) => {
    toggleFilter(selectedThirdSectionFilters, setSelectedThirdSectionFilters, value);
  };

  const toggleFourthSectionFilter = (value: string) => {
    toggleFilter(selectedFourthSectionFilters, setSelectedFourthSectionFilters, value);
  };

  return {
    selectedThirdSectionFilters,
    selectedFourthSectionFilters,
    toggleThirdSectionFilter,
    toggleFourthSectionFilter,
  };
};
